import image from "../Test/pokemon_2026_flat.psd"

// set to null to get out of testing
// otherwise clicking on any template thumb will use the overriding psd file.
export const template_override: any = null

